module.exports = __webpack_public_path__ + "img/info_circle.b77cabbf.svg";